// extracted by mini-css-extract-plugin
export default {"select":"OwnerField_select__MUV07"};